import BRU from '../assets/locations/brussels.png';
import LDN from '../assets/locations/london.png';
import PRG from '../assets/locations/prague.png';

const locations = [
  {
    key: 'location_1',
    image: LDN,
  },
  {
    key: 'location_2',
    image: BRU,
  },
  {
    key: 'location_3',
    image: PRG,
    },
];


export default locations;
